<template>
  <AlertModal v-bind="$attrs" show-btns btn-side="center" class="request-alert">
    <ul class="request-errors">
      <li v-for="(field, name) in errors" :key="name">
        <p
          class="request-errors__error"
          v-for="(error, index) in field"
          :key="index"
        >
          {{ error }}
        </p>
      </li>
    </ul>
  </AlertModal>
</template>

<script>
import AlertModal from "./AlertModal";
export default {
  name: "RequestAlert",
  inheritAttrs: false,
  components: { AlertModal },
  props: {
    errors: {
      type: [Array, Object]
    }
  }
};
</script>

<style lang="scss">
.request-alert {
  .alert-content {
    padding: 20px;
  }
}

.request-errors {
  @include nl();
  text-align: left;
  margin-top: 15px;
  font-size: 15px;
  line-height: 1.5;
  font-weight: normal;
  &__error {
    &::before {
      content: "— ";
    }
  }
}
</style>
